import React from 'react';
import Skeleton from '../Skeleton';

interface ListPageSkeletonProps {
  title: string;
  segmentCount?: number;
  filterCount?: number;
  showAction?: boolean;
}

/**
 * The loading twin of CommandBar + FilterBar. It renders the same layout
 * classes as the real bars, so the head is the same height before and after
 * the static data arrives and the table's top edge does not move.
 */
const ListPageSkeleton: React.FC<ListPageSkeletonProps> = ({
  title,
  segmentCount = 4,
  filterCount = 4,
  showAction = true,
}) => (
  <>
    <header className="command-bar">
      <h1 className="command-bar__title">{title}</h1>
      <div className="command-bar__search">
        <Skeleton height="32px" borderRadius="999px" animation="wave" />
      </div>
      {showAction && (
        <div className="command-bar__actions">
          <Skeleton width="132px" height="28px" borderRadius="24px" animation="wave" />
        </div>
      )}
    </header>
    <div className="list-filter-bar">
      {segmentCount > 0 && (
        <div className="list-filter-bar__segments">
          <Skeleton width={`${segmentCount * 78}px`} height="34px" borderRadius="8px" animation="wave" />
        </div>
      )}
      {segmentCount > 0 && filterCount > 0 && <span className="list-filter-bar__divider" aria-hidden="true" />}
      <div className="list-filter-bar__items">
        {Array.from({ length: filterCount }).map((_, i) => (
          <Skeleton key={i} width="112px" height="28px" borderRadius="999px" animation="wave" />
        ))}
      </div>
    </div>
  </>
);

export default ListPageSkeleton;
